module.exports = __webpack_public_path__ + "static/assets/863e160097ec4cadc5ca86df5d950d99.png";